import { render, staticRenderFns } from "./modal-buyer-protection.vue?vue&type=template&id=3c8ab1f6"
import script from "./modal-buyer-protection.vue?vue&type=script&lang=js"
export * from "./modal-buyer-protection.vue?vue&type=script&lang=js"
import style0 from "./modal-buyer-protection.vue?vue&type=style&index=0&id=3c8ab1f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports